import { InviteProtocol } from "./InviteProtocol";
import { InviteLaunchFlavor } from "./InviteLaunchFlavor";

export const InviteProtocolSection = () => (
  <section className="border-t border-white/15 bg-[#0f0f10] text-[#faf9f5]" data-testid="invite-protocol-section">
    <div className="mx-auto grid max-w-site grid-cols-1 items-stretch gap-10 px-6 py-14 md:px-10 md:py-20 lg:grid-cols-2 lg:gap-16" data-testid="invite-protocol-flavor-layout">
      <InviteProtocol />
      <InviteLaunchFlavor />
    </div>
  </section>
);